<div id="locationList" class="location-container ya-typography">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <nav mat-tab-nav-bar class="ya-tab-nav-bar ya-mat-tab-nav-bar">
      <a mat-tab-link *ngFor="let tabStep of tabLocationStep; let tabIndex = index" (click)="changeTab(tabIndex)"
        [active]="activeLink == tabStep">
        <span [langkey]="tabStep"></span>
      </a>
    </nav>
  </ya-subheader>
  <div class="ya-page-content">
    <div class="search-inupt-container">
      <input a11y_Input id="locationSearcInput" type="text" [placeholder]="setPlaceHolder()" class="ya-input-text"
        (keyup)="searchLocationFilter($event.target.value)" (blur)="setWebView()" [value]="searchLocationKey">
    </div>
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="location-map-tabs">
        <mat-tab-group mat-stretch-tabs dynamicHeight="true" [(selectedIndex)]="matGroupSelectedIndex"
          (swiperight)="swipeRightHandler()" (selectedIndexChange)="tabSelectedIndexChange($event)"
          animationDuration="20ms">
          <mat-tab lable="map">
            <ng-container *ngIf="initializeMap">
              <div class="map-wrapper">
                <GMapComponent [locationData]="mapLocationList" [fitBounds]="fitBounds" [latitude]="latitude"
                  [longitude]="longitude" [className]="'custom-agm-map'"></GMapComponent>
              </div>
            </ng-container>
          </mat-tab>
          <mat-tab label="locations">
            <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
              <div class="ya-item-list-contaner" #locationListView>
                <ng-container *ngFor="let location of locationList">
                  <div class="ya-content-item location-item">
                    <div class="location-like-wrapper">
                      <ya-favoritebutton [contentType]="contentType.Location" [likeStatus]="location.like"
                        [modelId]="location.hyp_cus_nr" [customClass]="'custom-favorite-button'">
                      </ya-favoritebutton>
                    </div>
                    <ng-container *ngIf="!isSmallView">
                      <div class="location-img" (click)="navigateToLocationDetail(location.hyp_cus_nr)">
                        <div class="aspect-ration-img-box">
                          <img class="ya_image" [src]="location.image_photo" alt="" />
                          <div class="gradient"></div>
                        </div>
                      </div>
                    </ng-container>
                    <div a11y_Button class="location-content" (click)="navigateToLocationDetail(location.hyp_cus_nr)">
                      <div class="location-content-wrapper">
                        <div class="location-content-header">
                          <h2>
                            {{location.label}}
                          </h2>
                        </div>
                        <div class="location-content-services">
                          <ng-container *ngIf="location.serviceBrowse">
                            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-menu"></div>
                          </ng-container>
                          <ng-container *ngIf="location.serviceInhouse">
                            <div class="inline-icon" inlineSVG="shop-icons.ya-hypersoft-tisch"></div>
                          </ng-container>
                          <ng-container *ngIf="location.servicePickup">
                            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-abholen"></div>
                          </ng-container>
                          <ng-container *ngIf="location.serviceDelivery">
                            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-liefern"></div>
                          </ng-container>
                        </div>
                      </div>
                      <div class="location-content-detail-wrapper">
                        <div>
                          <p>{{location.street}}, {{location.zipCode + " " +location.location}}</p>
                          <p><span langkey="phGlobal_OpenTime" class="opentimestitle"></span> <span
                              class="opentimes">{{location.openTime}}</span></p>
                        </div>
                        <ng-container *ngIf="location.distanceString">
                          <div class="location-distance">{{location.distance >= 1 ? location.distanceString : "< 1 km"}}
                              </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>